// extracted by mini-css-extract-plugin
export default {"characteristics":"Wnk4tX"};